import * as z from "zod";
import { UserRole } from "model/user/userRole";
import { Language } from "model/user/language";
import { FileSchema } from "model/user/file";

export const UserSchema = z.object({
  id: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string(),
  gender: z.string().nullable(),
  avatar: FileSchema.nullable(),
  dateOfBirth: z.string().nullable(),
  countryId: z.number().nullable(),
  emailAddress: z.string(),
  emailAddressVerified: z.boolean(),
  phoneNumber: z.string().nullable(),
  phoneNumberVerified: z.boolean(),
  role: z.nativeEnum(UserRole),
  organizationId: z.number().nullable(),
  languageId: z.nativeEnum(Language),
  timeZone: z.string(),
  isDisabled: z.boolean(),
  isMarketingConsent: z.boolean(),
  activatedAt: z.string().nullable(),
  signedInAt: z.string().nullable(),
});

export type UserModel = z.infer<typeof UserSchema>;
